export default [
    {
        name: 'introList',
        path: '/intro/list',
        component: require('@/pages/IntroList').default,
        props: (route) => ({
            model: null,
            id: null,
        }),
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'intro' })
        }
    },
    {
        name: 'introCreate',
        path: '/intro/create',
        component: require('@/pages/IntroCreate').default,
        meta: {
            back: { label: 'Intro Paragraphs', to: '/intro/list' },
            security: (auth) => auth.can({ action: 'create', model: 'intro' })
        }
    },
    {
        name: 'introView',
        path: '/intro/view/:introId',
        component: require('@/pages/IntroView').default,
        props: (route) => ({
            introId: +route.params.introId,
        }),
        meta: {
            back: { label: 'Intro Paragraphs', to: '/intro/list' },
            security: (auth) => auth.can({ action: 'view', model: 'intro' })
        }
    },
    {
        name: 'introEdit',
        path: '/intro/edit/:introId',
        component: require('@/pages/IntroEdit').default,
        props: (route) => ({
            introId: +route.params.introId,
        }),
        meta: {
            back: { label: ':introName', to: '/intro/view/:introId' },
            security: (auth) => auth.can({ action: 'edit', model: 'intro' })
        }
    },
]
